<template>
  <section>
    <Feature :title="$t('CPC_MAINTAIN')" :iconClass="'fa-handshake-o'">
      <FormRowTwo :fieldNameArr="[$t('FUNCTION') + ': ', $t('STATUS') + ': ', $t('DELTA_PN') + ': ', $t('VENDOR_PN') + ': ']"
        :fieldWidthArr="[362, 362, 362, 362]" :fieldSpanWidthArr="[100, 100, 100, 100]">
        <RadioGroup class="Input" v-model="rfqType" size="large" slot="a">
          <Radio label="COMPONENT">{{ $t('QUOTATION') }}</Radio>
          <Radio label="TOOLING">{{ $t('TOOLING') }}</Radio>
          <Radio label="RFQ">{{ $t('RFQ') }}</Radio>
        </RadioGroup>
        <Select class="Select" v-model="status" slot="b">
          <Option v-for="(item, index) in statusList" :value="item.description" :key="index">{{ item.description }}
          </Option>
        </Select>
        <Input class="Input" v-model="deltaPn" search :enter-button="$t('MORE')" @on-search="moreDeltaPn" slot="c" />
        <Input class="Input" v-model="vendorPn" search :enter-button="$t('MORE')" @on-search="moreVendorPn" slot="d" />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('APPLY_DATE')  + ': ', '~', $t('VENDOR_CODE') + ': ']"
        :fieldWidthArr="[362, 282, 412]" :fieldSpanWidthArr="[100, 20, 150]">
        <DatePicker class="Input" v-model="fromRfqDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')" slot="a">
        </DatePicker>
        <DatePicker class="Input" v-model="toRfqDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_TO')" slot="b">
        </DatePicker>
        <Input class="Input" v-model="vnCode" search :enter-button="$t('MORE')" @on-search="moreVnCode" slot="c" />
      </FormRowTwo>
      <ButtonRow>
        <Button type="success" @click="search($event, true)" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="info" @click="clear" slot="1">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
    </Feature>
    <Feature v-show="quotationView && rfqType == 'COMPONENT'" :title="'Data'" :iconClass="'fa-pencil-square-o'">
      <Row type="flex" justify="start" :gutter="16">
        <Col>
          <Button type="primary" @click="group">{{ $t("GROUP") }}</Button>
        </Col>
        <Col>
          <Button type="primary" @click="download">{{ $t("DOWNLOAD") }}</Button>
        </Col>
      </Row>
      <Table :columns="quotationColumnList" :data="quotationList" row-key="key">
        <template slot-scope="{ row, index }" slot="checkbox">
          <Checkbox v-if="quotationList[index].status.statusViewEnum === 'WAITING_BUYER'" v-model="quotationList[index].checked">
          </Checkbox>
        </template>
        <template slot-scope="{ row, index }" slot="rfqType">
          <span>{{ row.rfqType.description }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="formNo">
          <a style="color: #46a3ff;" @click="clickFormNo(row.uuid, row.formNo)">{{ row.formNo }}</a>
        </template>
        <template slot-scope="{ row, index }" slot="deltaPartNo">
          <a style="color: #46a3ff;" @click="clickDeltaPartNo(row.deltaPart)">{{ row.deltaPart }}</a>
        </template>
        <template slot-scope="{ row, index }" slot="vendor">
          <a style="color: #46a3ff;" @click="clickVendor(row.vendorCode)">{{ row.vendorName }}</a>
        </template>
        <template slot-scope="{ row, index }" slot="log">
          <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showLogModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="categoryAttributes">
          <Icon v-if="row.category && row.category !== 'OTHERS'" type="ios-paper" size="28" class="text-delta-blue" @click="showCategoryAttributesModal(index, row.category, row.formNo)" />
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <span v-text="row.status.description"></span>
        </template>
      </Table>
      <Row type="flex" justify="space-between">
        <Col type="flex" justify="start">
          {{ $t("COMMON_TEXT_FROM") }} {{ pageObj.page * pageObj.pageSize - (pageObj.pageSize - 1) }} {{ $t("COMMON_TEXT_TO") }}
          <span v-if="pageObj.totalCount < pageObj.page * pageObj.pageSize">{{ pageObj.totalCount }}</span>
          <span v-else> {{ pageObj.page * pageObj.pageSize }}</span>
          {{ $t("COMMON_TEXT_OF") }} {{ pageObj.totalCount }} {{ $t("COMMON_TEXT_ENTRIES") }}
        </Col>
        <Col type="flex" justify="end">
          <Page :total="pageObj.totalCount" :page-size="pageObj.pageSize" :prev-text="$t('COMMON_TEXT_PREV')" :next-text="$t('COMMON_TEXT_NEXT')" @on-change="changePage" @on-page-size-change="changePageSize" show-sizer :page-size-opts="[20, 50, 100]">
          </Page>
        </Col>
      </Row>
    </Feature>
    <Feature v-show="quotationView && rfqType == 'TOOLING'" :title="'Data'" :iconClass="'fa-pencil-square-o'">
      <Row type="flex" justify="start" :gutter="16">
        <Col>
          <Button type="primary" @click="groupTooling">{{ $t("GROUP") }}</Button>
        </Col>
      </Row>
      <TablePage :tableWidth="windowWidth" :columnsList="toolingColumnList" :resultList="quotationList" :pageObj="pageObj"
        @changePage="changePage"></TablePage>
    </Feature>
    <TablePage :tableWidth="windowWidth" v-show="quotationGroupView" :columnsList="quotationGroupColumnList"
      :resultList="quotationGroupList" :pageObj="groupPageObj" @changePage="changeGroupPageObj"></TablePage>
    <Feature v-show="rfqType === 'RFQ' && quotationListForRfq.length > 0" :title="'Data'" :iconClass="'fa-pencil-square-o'">
      <Table :columns="quotationColumnListForRfq" :data="quotationListForRfq" row-key="key">
        <template slot-scope="{ row, index }" slot="groupKey">
          <a style="color: #46a3ff;" @click="clickGroupKeyForRfq(row)" v-text="row.groupId"></a>
        </template>
      </Table>
      <Row type="flex" justify="space-between">
        <Col type="flex" justify="start">
          {{ $t("COMMON_TEXT_FROM") }} {{ pageObjForRfq.page * pageObjForRfq.pageSize - (pageObjForRfq.pageSize - 1) }} {{ $t("COMMON_TEXT_TO") }}
          <span v-if="pageObjForRfq.totalCount < pageObjForRfq.page * pageObjForRfq.pageSize">{{ pageObjForRfq.totalCount }}</span>
          <span v-else> {{ pageObjForRfq.page * pageObjForRfq.pageSize }}</span>
          {{ $t("COMMON_TEXT_OF") }} {{ pageObjForRfq.totalCount }} {{ $t("COMMON_TEXT_ENTRIES") }}
        </Col>
        <Col type="flex" justify="end">
          <Page :total="pageObjForRfq.totalCount" :page-size="pageObjForRfq.pageSize" :prev-text="$t('COMMON_TEXT_PREV')" :next-text="$t('COMMON_TEXT_NEXT')" @on-change="changePageForRfq" @on-page-size-change="changePageSizeForRfq" show-sizer :page-size-opts="[20, 50, 100]">
          </Page>
        </Col>
      </Row>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="deltaPnModel"
      :title="$t('DELTA_PN_MORE')" @on-ok="confirmDeltaPnValue">
      <Input v-model="deltaPnValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="vendorPnModel"
      :title="$t('VENDOR_PN_MORE')" @on-ok="confirmVendorPnValue">
      <Input v-model="vendorPnValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="vnCodeModel"
      :title="$t('VENDOR_CODE_MORE')" @on-ok="confirmVnCodeValue">
      <Input v-model="vnCodeValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logModel"
      title="Process Log">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <TablePage :columnsList="quotationLogColumnList" :resultList="quotationLogList" :tableMaxHeight="800"></TablePage>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="flowCommentModel" :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="flowComment"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="metalAttributeModel" :title="$t('METAL_CASE_ATTRIBUTES')">
      <MetalAttributes :metalQuotation="metalQuotation" :referencePrice="referencePrice" :priceList="priceList">
      </MetalAttributes>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="plasticAttributeModel" :title="$t('PLASTIC_CASE_ATTRIBUTES')">
      <PlasticAttributes :plasticQuotation="plasticQuotation" :referencePrice="referencePrice" :priceList="priceList">
      </PlasticAttributes>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="pwbAttributeModel" :title="$t('PWB_CASE_ATTRIBUTES')">
      <PwbAttributes :pwbQuotation="pwbQuotation" :priceList="priceList"></PwbAttributes>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertError } from "@/util/alert"
import { Translate, FloraEditorConfig } from "@/util/common"
import moment from "moment"
import MetalAttributes from "@/views/quotation/MetalAttributes"
import PlasticAttributes from "@/views/quotation/PlasticAttributes"
import PwbAttributes from "@/views/quotation/PwbAttributes"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "CpcMaintain",
  components: {
    MetalAttributes,
    PlasticAttributes,
    PwbAttributes,
    FormRowTwo
  },
  created() {
    const vueInstance = this
    vueInstance.$queryStatusList(vueInstance, 'cpc').then(data => {
      if (data) {
        vueInstance.statusList = data
        if (vueInstance.getCpcStatus() == "") {
          vueInstance.setCpcStatus(vueInstance.statusList[0].description)
          vueInstance.setCpcStatusEnum(vueInstance.statusList[0])
        }
        vueInstance.search(true)
      } else {
        AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
        })
        vueInstance.$router.push("/home")
      }
    })
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      groupPageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      pageObjForRfq: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      statusList: [],
      deltaPnValue: '',
      vendorPnValue: '',
      vnCodeValue: '',
      quotationSelectAllRef: false,
      deltaPnModel: false,
      vendorPnModel: false,
      vnCodeModel: false,
      logModel: false,
      flowCommentModel: false,
      metalAttributeModel: false,
      metalQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        rawMaterialType: {
          partNo: '',
          partNoDesc: ''
        },
        rmVendor: {
          vendorCode: ''
        },
        coilCenter: {
          vendorCode: ''
        },
        rmPrice: '',
        rmPriceDate: '',
        rmCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      plasticAttributeModel: false,
      plasticQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        model: '',
        resinType: {
          type: ''
        },
        resinVendor: {
          vendorCode: ''
        },
        resinNo: {
          partNo: '',
          partNoDesc: ''
        },
        distributor: {
          vendorCode: ''
        },
        resinColor: '',
        colorNo: '',
        rmPrice: '',
        rmPriceDate: '',
        dyeCost: '',
        cavity: '',
        tannage: '',
        hourlyRate: '',
        cycleTime: '',
        rmCost: '',
        injectingCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      pwbAttributeModel: false,
      pwbQuotation: {
        deltaExchangeRate: "",
        cpcExchangeRate: "",
        rfqBase: "",
        cclLaminateType: "",
        layer: "",
        pcbThickness: "",
        internalCoreThickness: "",
        tg: "",
        externalCopperThickness: "",
        internalCopperThickness: "",
        mainSourceCclSupplier: {
          vendorCode: ""
        },
        mainSourceCclShare: 0,
        mainCoreUlNumber: {
          partNoDesc: ""
        },
        mainCoreUP: "",
        secondSourceCclSupplier: {
          vendorCode: ""
        },
        secondCoreUlNumber: {
          partNoDesc: ""
        },
        secondCoreUP: "",
        pcbPrice: "",
        panelLength: "",
        panelWidth: "",
        pnLength: "",
        pnWidth: "",
        area: "",
        pnArea: "",
        supplierSheetSize: "",
        deltaSheetSize: "",
        panelSheet: "",
        pnInSheet: "",
        pnInPanel: "",
        pnUtilization: "",
        panelUtilization: "",
        combineRatio: "",
        numberOfDrill: "",
        slotLength: "",
        goldArea: "",
        materialCost: "",
        surfaceFinishCost: "",
        processCost: "",
        specialCostDown: "",
        deltaPnPriceUsd: "",
        deltaPnPrice: "",
        supplierRemark: ""
      },
      referencePrice: '',
      priceList: [],
      flowComment: '',
      quotationList: [],
      quotationListForRfq: [],
      quotationLogList: [],
      quotationGroupList: [],
      quotationGroupColumnList: [
        {
          title: this.$t('GROUP_KEY'),
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("a", {
              attrs: { style: "color:#46A3FF" },
              on: {
                click: () => {
                  this.setCpcGroupId(params.row.groupId)
                  this.setCpcGroupUuid(params.row.uuid)
                  if (this.rfqType == "COMPONENT") {
                    this.$router.push({ name: "CPC_MAINTAIN_DETAIL_GROUP_ID" })
                  } else if (this.rfqType == "TOOLING") {
                    this.$router.push({ name: "CPC_MAINTAIN_DETAIL_TOOLING_GROUP_ID" })
                  } else if (this.rfqType == "RFQ") {
                    this.$router.push({ name: "CPC_MAINTAIN_DETAIL_RFQ_GROUP_ID" })
                  }
                },
              },
            }, params.row.groupId)
          },
        },
        {
          title: "Form No.",
          width: 150,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.formNo) {
                html += "<lable>" + quotaion.formNo + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        },
        {
          title: this.$t('VENDOR_CODE'),
          width: 150,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.vendorCode) {
                html += "<lable>" + quotaion.vendorCode + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        },
        {
          title: this.$t('OA_VENDOR_NAME'),
          width: 250,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.vendorName) {
                html += "<lable>" + quotaion.vendorName + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        },
        {
          title: this.$t('PART_NO'),
          key: "partNo",
          width: 150,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.partNo) {
                html += "<lable>" + quotaion.partNo + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        }
      ],
      quotationLogColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ROLE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quotationRole",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowStatus",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "groupAccount",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row["groupAccount"].companyName)
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowAction",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            if (params.row.flowComment) {
              return h("Icon", {
                props: {
                  type: "ios-paper",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.flowComment = params.row.flowComment
                    this.flowCommentModel = true
                  },
                },
              })
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "created",
          width: 180,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PERSON_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "personEmail",
          width: 200,
          align: "center",
        },
      ],
      toolingColumnList: [
        {
          title: '',
          width: 40,
          align: "center",
          render: (h, params) => {
            return params.row.status.statusViewEnum == "WAITING_BUYER" ?
              h('div', [
                h('Checkbox', {
                  props: {
                    value: params.row.checked
                  },
                  on: {
                    'on-change': (e) => {
                      this.quotationList[params.index].checked = e
                    }
                  }
                })
              ]) : ""
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row["rfqType"].description + " (" + params.row.toolingQuotationType + ")")
          },
        },
        {
          title: "Form NO.",
          width: 70,
          align: "center",
          render: (h, params) => {
            return h("a", {
              attrs: { style: "color:#46A3FF" },
              on: {
                click: () => {
                  this.setCpcQuotationId(params.row.uuid)
                  this.setCpcFormNo(params.row.formNo)
                  this.$router.push({ name: "CPC_MAINTAIN_DETAIL_TOOLING_FORM_NO" })
                },
              },
            }, params.row.formNo)
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TOOLING_ID');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: "center",
          render: (h, params) => {
            return h("a", {
              attrs: { style: "color:#46A3FF" },
              on: {
                click: () => {
                  this.setCpcDeltaPnSingle(params.row.toolingId)
                  this.$router.push({ name: "CPC_MAINTAIN_DETAIL_TOOLING_ID" })
                },
              },
            }, params.row.toolingId)
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('DELTA_PN_DESCRIPTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("a", {
              attrs: { style: "color:#46A3FF" },
              on: {
                click: () => {
                  this.setCpcOaCode(params.row.vendorCode)
                  this.$router.push({ name: "CPC_MAINTAIN_DETAIL_TOOLING_VENDOR_NAME" })
                },
              },
            }, params.row.vendorName)
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "rfqDate",
          width: 110,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "price",
          width: 70,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "currency",
          width: 70,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "plant",
          width: 70,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LOG');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.logModel = true
                  this.quotationLogList = []
                  this.toggleLoading(true)
                  this.$queryQuotationLog(this, params.row.id).then(data => {
                    this.toggleLoading(false)
                    this.quotationLogList = data
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PENDING_DAYS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "pendingDay",
          width: 70,
          align: 'center',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: 'center',
          render(h, params) {
            return h("span", {}, params.row.status.description)
          }
        },
      ],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getCpcRfqType", "getCpcStatus", "getCpcDeltaPn", "getCpcVendorPn", "getCpcVendorCode",
      "getCpcFromRfqDate", "getCpcToRfqDate", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading", "setCpcRfqType", "setCpcStatus", "setCpcStatusEnum", "setCpcDeltaPn", "setCpcVendorPn", "setCpcVendorCode",
      "setCpcFromRfqDate", "setCpcToRfqDate", "setCpcQuotationId", "setCpcDeltaPnSingle", "setCpcOaCode", "setCpcGroupId", "setCpcFormNo", "setCpcGroupUuid"]),
    moreDeltaPn() {
      this.deltaPnModel = true
      this.setCpcDeltaPn("")
    },
    moreVendorPn() {
      this.vendorPnModel = true
      this.setCpcVendorPn("")
    },
    moreVnCode() {
      this.vnCodeModel = true
      this.setCpcVendorCode("")
    },
    confirmDeltaPnValue() {
      this.deltaPnValue.split('\n').forEach(a => {
        this.setCpcDeltaPn(this.getCpcDeltaPn().concat(a.trim() + ";"))
      })
      this.setCpcDeltaPn(this.getCpcDeltaPn().substr(0, this.getCpcDeltaPn().length - 1))
    },
    confirmVendorPnValue() {
      this.vendorPnValue.split('\n').forEach(a => {
        this.setCpcVendorPn(this.getCpcVendorPn().concat(a.trim() + ";"))
      })
      this.setCpcVendorPn(this.getCpcVendorPn().substr(0, this.getCpcVendorPn().length - 1))
    },
    confirmVnCodeValue() {
      this.vnCodeValue.split('\n').forEach(a => {
        this.setCpcVendorCode(this.getCpcVendorCode().concat(a.trim() + ";"))
      })
      this.setCpcVendorCode(this.getCpcVendorCode().substr(0, this.getCpcVendorCode().length - 1))
    },
    changePageSize(newPageSize) {
      const vueInstance = this;
      this.quotationSelectAllRef = false;
      vueInstance.pageObj.pageSize = newPageSize;
      vueInstance.pageObj.page = 0;
      vueInstance.toggleLoading(true);
      vueInstance.searchSingle(false)
        .then(result => {
          if (result === undefined) {
            return;
          }
          vueInstance.quotationList = result._embedded.cpcQuotationSearchResourceList;
          vueInstance.pageObj = {
            "page": result.page.number + 1,
            "totalPage": result.page.totalPages,
            "totalCount": result.page.totalElements,
            "pageSize": result.page.size
          };
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    changePageSizeForRfq(newPageSize) {
      const vueInstance = this;
      vueInstance.pageObjForRfq.pageSize = newPageSize;
      vueInstance.pageObjForRfq.page = 0;
      vueInstance.toggleLoading(true);
      vueInstance.searchRfq(false)
        .then(result => {
          if (result === undefined) {
            return;
          }
          vueInstance.quotationListForRfq = result.content;
          vueInstance.pageObjForRfq = {
            "page": result.number + 1,
            "totalPage": result.totalPages,
            "totalCount": result.totalElements,
            "pageSize": result.size
          };
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    changePage(page) {
      const vueInstance = this;
      this.quotationSelectAllRef = false;
      vueInstance.pageObj.page = page - 1;
      vueInstance.toggleLoading(true);
      vueInstance.searchSingle(false)
        .then(result => {
          if (result === undefined) {
            return;
          }
          vueInstance.quotationList = result._embedded.cpcQuotationSearchResourceList;
          vueInstance.pageObj = {
            "page": result.page.number + 1,
            "totalPage": result.page.totalPages,
            "totalCount": result.page.totalElements,
            "pageSize": result.page.size
          };
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    changePageForRfq(page) {
      const vueInstance = this;
      vueInstance.pageObjForRfq.page = page - 1;
      vueInstance.toggleLoading(true);
      vueInstance.searchRfq(false)
        .then(result => {
          if (result === undefined) {
            return;
          }
          vueInstance.quotationListForRfq = result.content;
          vueInstance.pageObjForRfq = {
            "page": result.number + 1,
            "totalPage": result.totalPages,
            "totalCount": result.totalElements,
            "pageSize": result.size
          };
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    changeGroupPageObj(page) {
      const vueInstance = this;
      vueInstance.groupPageObj.page = page - 1;
      vueInstance.toggleLoading(true);
      vueInstance.searchGroup(false)
        .then(result => {
          if (result === undefined) {
            return;
          }
          vueInstance.quotationGroupList = result._embedded.cpcGroupQuotationSearchResourceList;
          vueInstance.groupPageObj = {
            "page": result.page.number + 1,
            "totalPage": result.page.totalPages,
            "totalCount": result.page.totalElements,
            "pageSize": result.page.size
          };
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    search(init) {
      const vueInstance = this;
      if (!vueInstance.getCpcStatus()) {
        AlertInfo(vueInstance, vueInstance.$t("COMMON_MESSAGE_NOT_AUTH"))
          .then(() => {
            thvueInstanceis.$router.push("/home");
          });
        return;
      }
      vueInstance.toggleLoading(true);
      switch (vueInstance.getCpcRfqType()) {
        case "COMPONENT":
        case "TOOLING":
          Promise.all([vueInstance.searchSingle(init), vueInstance.searchGroup(init)])
            .then(resultList => {
              if (resultList.every(result => result === undefined)) {
                vueInstance.$Notice.success({
                  title: Translate("COMMON_MESSAGE_INFO"),
                  desc: Translate("COMMON_MESSAGE_INFO"),
                  render: h => h("span", [Translate("COMMON_TEXT_NOTHING")])
                });
                return;
              }
              resultList.forEach(result => {
                if (result === undefined) {
                  return;
                }
                if (result._embedded.cpcQuotationSearchResourceList) {
                  vueInstance.quotationList = result._embedded.cpcQuotationSearchResourceList;
                  vueInstance.pageObj = {
                    "page": result.page.number + 1,
                    "totalPage": result.page.totalPages,
                    "totalCount": result.page.totalElements,
                    "pageSize": result.page.size
                  };
                } else if (result._embedded.cpcGroupQuotationSearchResourceList) {
                  vueInstance.quotationGroupList = result._embedded.cpcGroupQuotationSearchResourceList;
                  vueInstance.groupPageObj = {
                    "page": result.page.number + 1,
                    "totalPage": result.page.totalPages,
                    "totalCount": result.page.totalElements,
                    "pageSize": result.page.size
                  };
                }
              });
            })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        case "RFQ":
          vueInstance.searchRfq(init)
            .then(result => {
              if (result === undefined) {
                vueInstance.$Notice.success({
                  title: Translate("COMMON_MESSAGE_INFO"),
                  desc: Translate("COMMON_MESSAGE_INFO"),
                  render: h => h("span", [Translate("COMMON_TEXT_NOTHING")])
                });
              }
              vueInstance.quotationListForRfq = result.content;
              vueInstance.pageObjForRfq = {
                "page": result.number + 1,
                "totalPage": result.totalPages,
                "totalCount": result.totalElements,
                "pageSize": result.size
              };
            })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
      }
    },
    searchSingle(init) {
      const vueInstance = this;
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
      }
      let queryData = {
        "rfqType": vueInstance.getCpcRfqType(),
        "status": vueInstance.statusList.find(status => status.description === vueInstance.getCpcStatus())["statusViewEnum"],
        "deltaPartNos": vueInstance.getCpcDeltaPn() === "" ? [] : vueInstance.getCpcDeltaPn().split(";"),
        "vendorPartNos": vueInstance.getCpcVendorPn() === "" ? [] : vueInstance.getCpcVendorPn().split(";"),
        "vendorCodes": vueInstance.getCpcVendorCode() === "" ? [] : vueInstance.getCpcVendorCode().split(";"),
        "fromRfqDate": vueInstance.getCpcFromRfqDate() === "" ? null : moment(vueInstance.getCpcFromRfqDate()).format("YYYY-MM-DD"),
        "toRfqDate": vueInstance.getCpcToRfqDate() === "" ? null : moment(vueInstance.getCpcToRfqDate()).format("YYYY-MM-DD"),
      }
      vueInstance.quotationList = [];
      return vueInstance.$queryQuotationMaster(vueInstance, queryData, "cpc", vueInstance.pageObj)
        .then(data => {
          if (data && data._embedded) {
            return data;
          }
        });
    },
    searchGroup(init) {
      const vueInstance = this;
      if (init) {
        vueInstance.groupPageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        };
      }
      let queryData = {
        "rfqType": vueInstance.getCpcRfqType(),
        "status": vueInstance.statusList.find(status => status.description === vueInstance.getCpcStatus())["statusViewEnum"],
        "deltaPartNos": vueInstance.getCpcDeltaPn() === "" ? [] : vueInstance.getCpcDeltaPn().split(";"),
        "vendorPartNos": vueInstance.getCpcVendorPn() === "" ? [] : vueInstance.getCpcVendorPn().split(";"),
        "vendorCodes": vueInstance.getCpcVendorCode() === "" ? [] : vueInstance.getCpcVendorCode().split(";"),
        "fromRfqDate": vueInstance.getCpcFromRfqDate() === "" ? null : moment(vueInstance.getCpcFromRfqDate()).format("YYYY-MM-DD"),
        "toRfqDate": vueInstance.getCpcToRfqDate() === "" ? null : moment(vueInstance.getCpcToRfqDate()).format("YYYY-MM-DD"),
      }
      vueInstance.quotationGroupList = [];
      return vueInstance.$queryQuotationMasterGroup(vueInstance, queryData, "cpc", vueInstance.groupPageObj)
        .then(data => {
          if (data && data._embedded) {
            return data;
          }
        });
    },
    searchRfq(init) {
      const vueInstance = this;
      if (init) {
        vueInstance.pageObjForRfq = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        };
      }
      let queryData = {
        "status": vueInstance.statusList.find(status => status.description === vueInstance.getCpcStatus())["statusViewEnum"],
        "deltaPartNos": vueInstance.getCpcDeltaPn() === "" ? [] : vueInstance.getCpcDeltaPn().split(";"),
        "vendorPartNos": vueInstance.getCpcVendorPn() === "" ? [] : vueInstance.getCpcVendorPn().split(";"),
        "vendorCodes": vueInstance.getCpcVendorCode() === "" ? [] : vueInstance.getCpcVendorCode().split(";"),
        "fromRfqDate": vueInstance.getCpcFromRfqDate() === "" ? null : moment(vueInstance.getCpcFromRfqDate()).format("YYYY-MM-DD"),
        "toRfqDate": vueInstance.getCpcToRfqDate() === "" ? null : moment(vueInstance.getCpcToRfqDate()).format("YYYY-MM-DD"),
      }
      vueInstance.quotationListForRfq = [];
      return vueInstance.$quotationHttp
        .post("/cpc/rfq/search?page=" + vueInstance.pageObjForRfq.page + "&size=" + vueInstance.pageObjForRfq.pageSize, queryData)
        .then(response => {
          if (response.data) {
            return response.data;
          }
        });
    },
    download() {
      this.$downloadExcel(this, "cpc", buildCriteria(this), "")
    },
    clear() {
      this.setCpcRfqType('COMPONENT')
      this.setCpcStatus(this.statusList[0].description)
      this.setCpcStatusEnum(this.statusList[0])
      this.setCpcDeltaPn('')
      this.setCpcVendorPn('')
      this.setCpcFromRfqDate('')
      this.setCpcToRfqDate('')
      this.setCpcVendorCode('')
      this.deltaPnValue = ''
      this.vendorPnValue = ''
      this.vnCodeValue = ''
    },
    group() {
      const vueInstance = this
      let selectQuoation = vueInstance.quotationList.filter(quotation => quotation.checked);
      if (selectQuoation.length == 0) {
        vueInstance.$Swal.fire({
          icon: "info",
          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
          html: "No Select Un-Group Data",
        })
      } else {
        const formNoList = [];
        selectQuoation.forEach(quotation => {
          formNoList.push(quotation.formNo);
        })
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/cpc/group", { formNoList })
          .then((response) => {
            this.setCpcGroupId(response.data.groupId)
            this.setCpcGroupUuid(response.data.uuid)
            if (this.rfqType === "COMPONENT") {
              this.$router.push({ name: "CPC_MAINTAIN_DETAIL_GROUP_ID" })
            } else {
              this.$router.push({ name: "CPC_MAINTAIN_DETAIL_TOOLING_GROUP_ID" })
            }
          })
          .catch((error) => {
            console.error(error);
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          })
          .finally(() => {
            vueInstance.toggleLoading(false);
          });
      }
    },
    groupTooling() {
      const vueInstance = this;
      let selectQuoation = vueInstance.quotationList.filter(quotation => quotation.checked);
      if (selectQuoation.length == 0) {
        AlertInfo(vueInstance, "No Select Un-Group Data")
          .then(() => { });
        return;
      }
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .post("/cpc/group/tooling", {
          formNoList: selectQuoation.map(quotation => quotation.formNo)
        })
        .then(response => {
          vueInstance.setCpcGroupId(response.data.groupId);
          vueInstance.setCpcGroupUuid(response.data.uuid);
          vueInstance.$router.push({
            name: "CPC_MAINTAIN_DETAIL_TOOLING_GROUP_ID"
          });
        })
        .catch(error => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => { });
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    clickFormNo(uuid, formNo) {
      this.setCpcQuotationId(uuid);
      this.setCpcFormNo(formNo);
      this.$router.push({
        name: "CPC_MAINTAIN_DETAIL_FORM_NO"
      });
    },
    clickDeltaPartNo(deltaPartNo) {
      this.setCpcDeltaPnSingle(deltaPartNo);
      this.$router.push({
        name: "CPC_MAINTAIN_DETAIL_PART_NO"
      });
    },
    clickVendor(vendorCode) {
      this.setCpcOaCode(vendorCode);
      this.$router.push({
        name: "CPC_MAINTAIN_DETAIL_VENDOR_NAME"
      });
    },
    showLogModal(index, uuid) {
      this.toggleLoading(true);
      this.$queryQuotationLog(this, uuid)
        .then(data => {
          this.quotationUuid = uuid;
          this.quotationLogList = data;
          this.logModel = true;
        }).catch(error => {
          AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
            .then(() => { });
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    showCategoryAttributesModal(index, category, formNo) {
      switch (category) {
        case "METAL":
          this.$showMetalCategoryAttribute(this, formNo);
          break;
        case "PLASTIC":
          this.$showPlasticCategoryAttribute(this, formNo);
          break;
        case "PWB":
          this.$showPwbCategoryAttribute(this, formNo);
          break;
      }
    },
    clickGroupKeyForRfq(row) {
      const vueInstance = this;
      vueInstance.setCpcGroupId(row.groupId);
      vueInstance.setCpcGroupUuid(row.uuid);
      vueInstance.$router.push({
        name: "CPC_MAINTAIN_DETAIL_RFQ_GROUP_ID",
        params: {
          rfqStatus: row.rfqStatus
        }
      });
    }
  },
  computed: {
    quotationView() {
      return this.quotationList && this.quotationList.length > 0
    },
    quotationGroupView() {
      return this.quotationGroupList && this.quotationGroupList.length > 0
    },
    rfqType: {
      get() {
        return this.getCpcRfqType()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        this.quotationListForRfq = [];
        return this.setCpcRfqType(value)
      }
    },
    status: {
      get() {
        return this.getCpcStatus()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        this.setCpcStatusEnum(this.statusList.find(status => status.description == value))
        return this.setCpcStatus(value)
      }
    },
    deltaPn: {
      get() {
        return this.getCpcDeltaPn()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcDeltaPn(value.trim())
      }
    },
    vendorPn: {
      get() {
        return this.getCpcVendorPn()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcVendorPn(value.trim())
      }
    },
    vnCode: {
      get() {
        return this.getCpcVendorCode()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcVendorCode(value.trim())
      }
    },
    fromRfqDate: {
      get() {
        return this.getCpcFromRfqDate()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcFromRfqDate(value)
      }
    },
    toRfqDate: {
      get() {
        return this.getCpcToRfqDate()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcToRfqDate(value)
      }
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    quotationColumnList() {
      return [{
        renderHeader: (h, params) => {
          return h('div', [
            h('Checkbox', {
              props: {
                'value': this.quotationSelectAllRef
              },
              on: {
                'on-change': (e) => {
                  this.quotationSelectAllRef = !this.quotationSelectAllRef;
                  this.quotationList.forEach((item, index) => {
                    this.$set(this.quotationList[index], 'checked', e);
                  })
                }
              }
            })
          ])
        },
        width: 40,
        align: "center",
        slot: "checkbox"
      }, {
        title: this.$t("RFQ_TYPE"),
        width: 60,
        align: "center",
        slot: "rfqType"
      }, {
        title: this.$t("FORM_NO"),
        width: 100,
        align: "center",
        slot: "formNo"
      }, {
        title: this.$t("CATEGORY"),
        width: 60,
        align: "center",
        key: "category"
      }, {
        title: this.$t("DELTA_PN"),
        width: 70,
        align: "center",
        slot: "deltaPartNo"
      }, {
        title: this.$t("DELTA_PN_DESCRIPTION"),
        width: 100,
        align: "center",
        key: "deltaPartDesc"
      }, {
        title: this.$t("OA_VENDOR_NAME"),
        width: 100,
        align: "center",
        slot: "vendor"
      }, {
        title: this.$t("VENDOR_PN"),
        width: 100,
        align: "center",
        key: "vendorPartNo"
      }, {
        title: this.$t("SEND_TO_QUOTATION_OA_CODE"),
        width: 120,
        align: "center",
        key: "vendorCode"
      }, {
        title: this.$t("RFQ_DATE"),
        width: 110,
        align: "center",
        key: "rfqDate"
      }, {
        title: this.$t("UNIT_PRICE"),
        width: 70,
        align: "center",
        key: "price"
      }, {
        title: this.$t("CURRENCY"),
        width: 70,
        align: "center",
        key: "currency"
      }, {
        title: this.$t("PLANT"),
        width: 70,
        align: "center",
        key: "plant"
      }, {
        title: this.$t("LOG"),
        width: 50,
        align: "center",
        slot: "log"
      }, {
        title: this.$t("CATEGORY_ATTRIBUTES"),
        width: 50,
        align: "center",
        slot: "categoryAttributes"
      }, {
        title: this.$t("PENDING_DAYS"),
        width: 70,
        align: "center",
        key: "pendingDay"
      }, {
        title: this.$t("STATUS"),
        width: 70,
        align: "center",
        slot: "status"
      }];
    },
    quotationColumnListForRfq() {
      return [{
        title: this.$t("GROUP_KEY"),
        width: 150,
        align: "center",
        slot: "groupKey"
      }, {
        title: this.$t("VENDOR_CODE"),
        width: 150,
        align: "center",
        key: "vendorCode"
      }, {
        title: this.$t("OA_VENDOR_NAME"),
        width: 250,
        align: "center",
        key: "vendorName"
      }];
    }
  }
}

function query(vueInstance, queryData) {
  return vueInstance.$queryQuotationMaster(vueInstance, queryData, "cpc", vueInstance.pageObj)
}

function queryGroup(vueInstance, queryData) {
  return vueInstance.$queryQuotationMasterGroup(vueInstance, queryData, "cpc", vueInstance.groupPageObj)
}

function buildCriteria(vueInstance) {
  let deltaPnArray = []
  vueInstance.getCpcDeltaPn().split(';').forEach(a => {
    deltaPnArray.push(a)
  })

  let vendorPnArray = []
  vueInstance.getCpcVendorPn().split(';').forEach(a => {
    vendorPnArray.push(a)
  })

  let vnCodeArray = []
  vueInstance.getCpcVendorCode().split(';').forEach(a => {
    vnCodeArray.push(a)
  })
  return {
    "rfqType": vueInstance.getCpcRfqType(),
    "status": vueInstance.statusList.find(status => status.description == vueInstance.getCpcStatus())['statusViewEnum'],
    "deltaPartNos": vueInstance.getCpcDeltaPn() == "" ? [] : deltaPnArray,
    "vendorPartNos": vueInstance.getCpcVendorPn() == "" ? [] : vendorPnArray,
    "vendorCodes": vueInstance.getCpcVendorCode() == "" ? [] : vnCodeArray,
    "fromRfqDate": vueInstance.getCpcFromRfqDate() == "" ? null : moment(vueInstance.getCpcFromRfqDate()).format('YYYY-MM-DD'),
    "toRfqDate": vueInstance.getCpcToRfqDate() == "" ? null : moment(vueInstance.getCpcToRfqDate()).format('YYYY-MM-DD'),
  }
}

</script>

<style scoped></style>